module.exports = __webpack_public_path__ + "img/logo_square_1.7eb4bff2.jpeg";